/** Admin / Accountant pick destination agent once on Receive (locked for Deliver). */

export const RECEIVING_AGENT_PICKER_ROLES = new Set([
  'Admin',
  'System Admin',
  'Accountant',
])

export function shouldPickReceivingAgent(user, status) {
  if (!user || !RECEIVING_AGENT_PICKER_ROLES.has(user.role)) return false
  return String(status || '') === 'Received'
}

export function shipmentReceiverHubId(row) {
  const hub =
    row?.receiver_location_hub_id ??
    row?.receiver_location_hub ??
    row?.to_location_id
  if (hub === null || hub === undefined || hub === '') return null
  const n = Number(hub)
  return Number.isNaN(n) ? null : n
}

export function uniqueReceiverHubIds(shipments = []) {
  const ids = new Set()
  for (const row of shipments) {
    const hubId = shipmentReceiverHubId(row)
    if (hubId != null) ids.add(hubId)
  }
  return [...ids]
}

export function receiverHubLabelForShipment(row) {
  return (
    row?.receiver_location ||
    row?.consignee_location ||
    row?.receiver_location_name ||
    'Destination branch'
  )
}

export function receiverHubLabel(shipments = []) {
  if (!shipments.length) return ''
  return receiverHubLabelForShipment(shipments[0])
}

/** Group selected GCs by destination hub for per-branch agent pickers. */
export function groupShipmentsByReceiverHub(shipments = []) {
  const map = new Map()
  for (const row of shipments) {
    const hubId = shipmentReceiverHubId(row)
    if (hubId == null) continue
    if (!map.has(hubId)) {
      map.set(hubId, {
        hubId,
        label: receiverHubLabelForShipment(row),
        shipments: [],
      })
    }
    map.get(hubId).shipments.push(row)
  }
  return [...map.values()].sort((a, b) =>
    String(a.label).localeCompare(String(b.label)),
  )
}

/** Map shipment_id -> agent user_id from per-hub selections. */
export function buildReceiverAgentByShipment(shipments, hubAgentPick) {
  const out = {}
  for (const row of shipments) {
    const hubId = shipmentReceiverHubId(row)
    const sid = String(row?.shipment_id || '').trim()
    if (!sid || hubId == null) continue
    const pick = hubAgentPick?.[hubId]
    const agents = pick?.agents || []
    const uid =
      pick?.selectedUserId ||
      (agents.length === 1 ? agents[0].user_id : null)
    if (uid) out[sid] = String(uid)
  }
  return out
}

export function validateHubAgentSelections(shipments, hubAgentPick) {
  const groups = groupShipmentsByReceiverHub(shipments)
  for (const group of groups) {
    const pick = hubAgentPick?.[group.hubId]
    if (pick?.loading) {
      return 'Still loading destination agents…'
    }
    const agents = pick?.agents || []
    if (agents.length === 0) {
      return `No active agent at ${group.label}.`
    }
    const selected = pick?.selectedUserId
    if (agents.length > 1 && !String(selected || '').trim()) {
      return `Select the destination agent for ${group.label}.`
    }
    if (agents.length === 1) {
      continue
    }
    if (!selected) {
      return `Select the destination agent for ${group.label}.`
    }
  }
  if (groups.length === 0 && shipments.length > 0) {
    return 'Selected shipments have no destination branch on file.'
  }
  return null
}
